export default __webpack_public_path__ + "sounds/Fail.mp3";